/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./lib/locales (ignored)
// module id = 983
// module chunks = 1